// extracted by mini-css-extract-plugin
export default {"form":"classes_form__AYVie","form-container":"classes_form-container__gGO+4","button-container":"classes_button-container__aY3jx"};